import React, { useState, useEffect } from 'react';
import { Grid, Typography, Paper, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth.js';
import { useNotification } from "../../components/NotificationContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from 'axios';
const Reports = () => {
  useAuth();
  const showNotification = useNotification();
  const navigate = useNavigate();

  const [salesData, setSalesData] = useState([ ]);
  const [totalSales, setTotalSales] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const token = localStorage.getItem('token');
  useEffect(() => {
    const fetchSalesData = async () => {
      try {

  
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/orders/DailyReportOrders/admin`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        // API'den gelen veriyi setState ile state'e atıyoruz
        const formattedData = response.data.map((order) => ({
          orderDate: order.order_date,
          totalPrice: parseFloat(order.total_price)
        }));
  
        setSalesData(formattedData);

      } catch (error) {
        console.error('Satış verileri alınamadı:', error);
      }
    };
  
    fetchSalesData();
  }, []);
  // Geri butonuna tıklama işlemi
  const handleBackClick = () => {
    navigate(-1);
  };

  // Toplam satış ve toplam fiyat hesaplama
  const calculateTotal = (sales) => {
    let total = 0;
    let amount = 0;
    sales.forEach(sale => {
      total += 1; // Her bir siparişi bir satış olarak sayıyoruz
      amount += sale.totalPrice;
    });
    setTotalSales(total);
    setTotalAmount(amount);
  };

  useEffect(() => {
    calculateTotal(salesData); // İlk verilerle toplam hesaplama
  }, [salesData]);

  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid size={{ xs: 12, sm: 10,md:10 }}>
        <Paper elevation={5} style={{ padding: '30px', borderRadius: '15px', backgroundColor: '#ffffff' }}>
          <IconButton onClick={handleBackClick} style={{ marginRight: '10px' }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" gutterBottom align="center" style={{ fontWeight: 600, color: '#3f51b5' }}>
            Günlük Sipariş Raporu
          </Typography>

          <TableContainer component={Paper} style={{ marginTop: '20px' }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center">Sipariş Zamanı</TableCell>
                  <TableCell align="center">Ödeme Yöntemi</TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center">Toplam Fiyat</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
  {salesData.length === 0 ? (
    <TableRow>
      <TableCell colSpan={4} align="center">
        <Typography variant="body1" style={{ color: '#757575', fontStyle: 'italic' }}>
          Henüz gün içinde sipariş gelmedi.
        </Typography>
      </TableCell>
    </TableRow>
  ) : (
    salesData.map((sale, index) => (
      <TableRow key={index}>
        <TableCell align="center">{new Date(sale.orderDate).toLocaleString()}</TableCell>
        <TableCell align="center">Sanal POS</TableCell>
        <TableCell align="center"></TableCell>
        <TableCell align="center">{sale.totalPrice.toFixed(2)} ₺</TableCell>
      </TableRow>
    ))
  )}
</TableBody>
              <TableFooter>
  <TableRow>
    <TableCell colSpan={1} align="right">
      <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '18px', color: '#d32f2f' }}>
        Toplam Sipariş Sayısı:
      </Typography>
    </TableCell>
    <TableCell align="">
      <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '18px', color: '#d32f2f' }}>
        {totalSales}
      </Typography>
    </TableCell>
    <TableCell colSpan={1} align="right">
      <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '18px', color: '#d32f2f' }}>
        Toplam Fiyat:
      </Typography>
    </TableCell>
    <TableCell align="center">
      <Typography variant="h6" style={{ fontWeight: 'bold', fontSize: '18px', color: '#d32f2f' }}>
        {totalAmount.toFixed(2)} ₺
      </Typography>
    </TableCell>
  </TableRow>
</TableFooter>

            </Table>
          </TableContainer>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default Reports;
